/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".region-banner[_ngcontent-%COMP%]{font-size:10px;margin:10px;border-radius:10px;background:var(--ion-color-warning);padding:10px}"];
export { styles as styles };
